import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { BaseApi } from 'src/backend/api/base-api';
import { UserService } from 'src/backend/services/user-access-services/user.service';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class UserConfigurationsService {
  defaultPlant: any;

  constructor(private baseApi: BaseApi, private userService: UserService) {
    this.getProfileInformation();
  }

  getProfileInformation() {
    this.userService.getUserProfile().subscribe({
      next: (response) => {
        const userProfile = response;
        this.defaultPlant = userProfile.userPlants.find(
          (plant: any) => plant.isDefault === true
        );
      },
      error: ({ error }) => {
        console.log(error);
      },
    });
  }

  public currencyFormatter(currency) {
    // Convert the currency to a number
    const numericCurrency = Number(currency);

    // Check if the conversion was successful
    if (isNaN(numericCurrency)) {
      return currency; // Handle invalid input
    }

    // Get default and user configurations
    const { currencySymbol: plantSymbol, reportNumberFormat: plantNumberFormat } =
      this.defaultPlant || {};
    const userConfig = this.baseApi.getUserConfigurations() || {};
    const { currencySymbol: userSymbol, reportNumberFormat: userNumberFormat } = userConfig;

    // Determine the format and sign to use
    const sign = userSymbol || plantSymbol || 'SAR';
    const format = userNumberFormat || plantNumberFormat || '#,##0.00';

    // Format the currency value based on the chosen format
    let formatted;

    // Handle the decimal and thousands separator based on the format
    switch (format) {
      case '#,##0.00':
        formatted = numericCurrency
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case '#,##0':
        formatted = numericCurrency
          .toFixed(0)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case '#.##0,00':
        formatted = numericCurrency
          .toFixed(2)
          .toString()
          .replace('.', ',')
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      case '#.##0':
        formatted = numericCurrency
          .toFixed(0)
          .toString()
          .replace('.', ',')
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      case '0.00':
        formatted = numericCurrency.toFixed(2);
        break;
      case '0,00':
        formatted = numericCurrency.toFixed(2).toString().replace('.', ',');
        break;
      case '#,###.##':
        formatted = numericCurrency
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case '# ###,##':
        formatted = numericCurrency
          .toFixed(2)
          .toString()
          .replace('.', ',')
          .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        break;
      case '#,##0.000':
        formatted = numericCurrency
          .toFixed(3)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case '#,##0.0000':
        formatted = numericCurrency
          .toFixed(4)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      default:
        formatted = numericCurrency.toString(); // Fallback if format is unrecognized
    }

    return sign + formatted;
  }
  public numberFormatter(currency) {
    // Convert the currency to a number
    const numericCurrency = Number(currency);

    // Check if the conversion was successful
    if (isNaN(numericCurrency)) {
      return currency; // Handle invalid input
    }

    // Get default and user configurations
    const { currencySymbol: plantSymbol, reportNumberFormat: plantNumberFormat } =
      this.defaultPlant || {};
    const userConfig = this.baseApi.getUserConfigurations() || {};
    const { currencySymbol: userSymbol, reportNumberFormat: userNumberFormat } = userConfig;

    // Determine the format and sign to use
    const sign = userSymbol || plantSymbol || 'SAR';
    const format = userNumberFormat || plantNumberFormat || '#,##0.00';

    // Format the currency value based on the chosen format
    let formatted;

    // Handle the decimal and thousands separator based on the format
    switch (format) {
      case '#,##0.00':
        formatted = numericCurrency
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case '#,##0':
        formatted = numericCurrency
          .toFixed(0)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case '#.##0,00':
        formatted = numericCurrency
          .toFixed(2)
          .toString()
          .replace('.', ',')
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      case '#.##0':
        formatted = numericCurrency
          .toFixed(0)
          .toString()
          .replace('.', ',')
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      case '0.00':
        formatted = numericCurrency.toFixed(2);
        break;
      case '0,00':
        formatted = numericCurrency.toFixed(2).toString().replace('.', ',');
        break;
      case '#,###.##':
        formatted = numericCurrency
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case '# ###,##':
        formatted = numericCurrency
          .toFixed(2)
          .toString()
          .replace('.', ',')
          .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        break;
      case '#,##0.000':
        formatted = numericCurrency
          .toFixed(3)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case '#,##0.0000':
        formatted = numericCurrency
          .toFixed(4)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      default:
        formatted = numericCurrency.toString(); // Fallback if format is unrecognized
    }

    return formatted;
  }


  public formatField(value: any, formatType: string): string {
    if (!value) return '';
    const { DateFormat: userDateFormat, TimeFormat: userTimeFormat } =
      this.baseApi.getUserConfigurations() || {};
    const { dateFormat: plantDateFormat, timeFormat: plantTimeFormat } =
      this.baseApi.getPlantConfigurations() || {};
    const dateFormat = userDateFormat || plantDateFormat || Constants.DEFAULT_DATE_FORMAT;
    const timeFormat = userTimeFormat || plantTimeFormat || Constants.DEFAULT_TIME_FORMAT;
    const formattedValue = moment(value);
    switch (formatType) {
      case 'dateOnly':
        return formattedValue.format(dateFormat);
      case 'timeOnly':
        return formattedValue.format(timeFormat);
      case 'dateTime':
      default:
        return formattedValue.format(`${dateFormat} ${timeFormat}`);
    }
  }


  formatCellData(value: any, formatType: string): string {
    return this.formatField(value, formatType);
  }

  getDateFormat(formatType: string) {
    const { DateFormat: userDateFormat, TimeFormat: userTimeFormat } =
      this.baseApi.getUserConfigurations() || {};
    const { dateFormat: plantDateFormat, timeFormat: plantTimeFormat } =
      this.baseApi.getPlantConfigurations() || {};

    let dateFormat = userDateFormat || plantDateFormat || Constants.DEFAULT_DATE_FORMAT;
    const timeFormat = userTimeFormat || plantTimeFormat || Constants.DEFAULT_TIME_FORMAT;
    dateFormat = dateFormat.replace(/Y/g, 'y').replace(/D/g, 'd');
    if (formatType === 'date') {
      return dateFormat;
    } else if (formatType === 'date-time') {
      return dateFormat + ' ' + timeFormat;
    }
    else if (formatType === 'time') {
      return timeFormat;
    }
  }

  getDateFormatNgXdatePicker(formatType: string) {
    const { DateFormat: userDateFormat, TimeFormat: userTimeFormat } =
      this.baseApi.getUserConfigurations() || {};
    const { dateFormat: plantDateFormat, timeFormat: plantTimeFormat } =
      this.baseApi.getPlantConfigurations() || {};

    let dateFormat = userDateFormat || plantDateFormat || Constants.DEFAULT_DATE_FORMAT;
    const timeFormat = userTimeFormat || plantTimeFormat || Constants.DEFAULT_TIME_FORMAT;
    if (formatType === 'date') {
      return dateFormat;
    } else if (formatType === 'date-time') {
      return dateFormat + ' ' + timeFormat;
    }
    else if (formatType === 'time') {
      return timeFormat;
    }
  }
}
